// Helpers for rendering user-authored text through v-html without allowing
// script injection (stored XSS). Always escape BEFORE adding any markup.

export function escapeHtml(text) {
  return String(text == null ? '' : text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

// Escapes the input, then converts plain URLs into <a> tags. The result is the
// only HTML the string can contain, so it is safe to bind with v-html.
export function linkify(inputText) {
  let replacedText = escapeHtml(inputText);

  //URLs starting with http://, https://, or ftp://
  // eslint-disable-next-line no-useless-escape
  const replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
  replacedText = replacedText.replace(replacePattern1, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');

  //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
  // eslint-disable-next-line no-useless-escape
  const replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank" rel="noopener noreferrer">$2</a>');

  return replacedText;
}
